'use strict';

/*
 * SP/PC判別
 */
var is_sp = function is_sp() {
  if (window.innerWidth <= 1000) {
    return true;
  } else {
    return false;
  }
};

/*
 * URI解析
 */
var parse_uri = function parse_uri(uri) {
  var target = uri == null ? location.href : uri;
  var parsed = new URI(target);
  var query = parsed.search(true);
  return query;
};

/*
 * pushState
 */
var change_uri = function change_uri(param) {
  var l = location;
  var base = l.protocol + '//' + l.host + l.pathname + '?';
  var new_uri = base + $.param(param);
  window.history.pushState(null, null, new_uri);
};

/*
 * 関数の遅延実行
 */
var delay = function () {
  var timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
}();

/*
 * 高さを揃える
 */
var line_height = function line_height(el) {
  var min_h = 0;
  el.each(function () {
    var h = $(this).outerHeight();
    if (h > min_h) {
      min_h = h;
    }
  });
  el.outerHeight(min_h);
};

/*
 * Googleマップ
 */
var render_map = function render_map(el_id, lat, lng) {
  var latlng = new google.maps.LatLng(lat, lng);
  var canvas = document.getElementById(el_id);
  var map_param = {
    zoom: 16,
    center: latlng,
    mapTypeControl: false,
    streetViewControl: false,
    scrollwheel: false,
    draggable: true,
    gestureHandling: 'greedy'
  };
  var map = new google.maps.Map(canvas, map_param);
  var marker = new google.maps.Marker({
    position: latlng,
    map: map
  });
  google.maps.event.trigger(map, 'resize');
  map.setCenter(latlng);
  google.maps.event.addDomListener(window, 'resize', function () {
    map.panTo(latlng);
  });
};

/*
 * ハッシュ付きURLへ遷移時 スムーススクロール
 */
var hash_scroll = function hash_scroll() {
  var hash = location.hash;
  if (hash) {
    var target = $(hash);
    var head_h = $('header').outerHeight();
    var gnav_h = $('.gnav').outerHeight();
    var offset = is_sp() ? head_h + 20 : head_h + gnav_h + 20;
    var position = target.offset().top - offset;
    $('body,html').animate({ scrollTop: position }, 0);
  }
};

(function ($) {
  $(window).on('load', function ($) {

    delay(function () {
      hash_scroll();
    }, 500);
  });
})(jQuery);

(function ($) {
  $(document).ready(function ($) {

    /*
     * スムーススクロール
     */
    $('a[href^="#"]').on('click', function (event) {
      event.preventDefault();
      var target = $($(this).attr('href'));
      var head_h = $('header').outerHeight();
      var gnav_h = $('.gnav').outerHeight();
      var offset = is_sp() ? head_h + 20 : head_h + gnav_h + 20;
      var position = target.offset().top - offset;
      $('body,html').animate({ scrollTop: position }, 500);
    });

    /*
     * ページトップに戻る
     */
    $('#scrolltop').off('click').on('click', function (event) {
      event.preventDefault();
      $('html,body').animate({ scrollTop: 0 }, 500);
    });
    $(window).on('scroll', function () {
      if ($(window).scrollTop() > 100) {
        $('#scrolltop').addClass('active');
      } else {
        $('#scrolltop').removeClass('active');
      }
    });
  });
})(jQuery);

(function ($) {
  $(window).on('load', function ($) {});
})(jQuery);

(function ($) {
  $(document).ready(function ($) {});
})(jQuery);

(function ($) {
  $(window).on('load', function ($) {});
})(jQuery);

(function ($) {
  $(document).ready(function ($) {

    if (is_sp()) {
      $('header .gnav a').on('click', function () {
        $(this).closest('.gnav').removeClass('active');
        $('header .sp_menu a').removeClass('active');
      });
    }
    $('header .sp_menu').on('click', function () {
      $(this).find('a').toggleClass('active');
      $('header .gnav').toggleClass('active');
    });
    $('header .gnav .more > a').on('click', function (event) {
      event.preventDefault();
    });
  });
})(jQuery);

(function ($) {
  $(document).ready(function ($) {
    if ($('body').hasClass('home')) {

      /*
       * メインビジュアル リサイズ
       */
      if (is_sp()) {
        var resize_h = $(window).innerHeight() - 125;
        $('.mainvisual, .mainvisual ul, .mainvisual li, .bx-wrapper').outerHeight(resize_h);
      }

      /*
       * メインビジュアル 投資家のみなさまへ
       * テキストとリンクが重ならないかチェック
       */
      var text_overlap = function text_overlap() {
        var link = $('.mainvisual .sp_company_link');
        var link_top = link.offset().top;
        var text_max_h = 0;
        $('.mainvisual .text').each(function () {
          var text_h = $(this).outerHeight();
          text_max_h = text_h > text_max_h ? text_h : text_max_h;
        });
        var text_bottom = text_max_h + 55;
        if (link_top < text_bottom + 20) {
          return text_bottom - link_top;
        } else {
          return false;
        }
      };

      /*
       * メインビジュアル
       * テキストとリンクが重ならないかチェック
       * 重なっていれば再リサイズ
       */
      if (is_sp() && text_overlap()) {
        var _resize_h = $(window).innerHeight() - 125 + text_overlap() + 20;
        $('.mainvisual, .mainvisual ul, .mainvisual li, .bx-wrapper').outerHeight(_resize_h);
      }

      /*
       * メインビジュアル スライダー
       */
      $('.mainvisual ul').bxSlider({
        mode: 'horizontal',
        pager: true,
        auto: true,
        autostart: true,
        speed: 1500,
        pause: 7500,
        responsive: false,
        preloadImages: 'all'
      });
    }
  });
})(jQuery);

(function ($) {
  $(document).ready(function ($) {

    /*
     * ホテル詳細ページ
     */
    if ($('body').hasClass('single-hotel')) {
      // arrow
      var set_arrow_offset = function set_arrow_offset() {
        $('.splide__arrow').each(function (i, el) {
          var $wrap = $(el).closest('.splide');
          var img_h = $wrap.find('.splide__list .image').outerHeight();
          var arrow_h = $(el).outerHeight();
          var arrow_offset = (img_h - arrow_h) / 2;
          $(el).css('top', arrow_offset);
        });
      };
      // mount


      // 地図
      var lat = $('#map').data('lat'),
          lng = $('#map').data('lng');
      render_map('map', lat, lng);
      // スライド
      var gallery_main = new Splide('#gallery_main', {
        perPage: 1,
        speed: 350,
        gap: 0,
        rewind: false,
        pagination: false
      });
      var gallery_thumb = new Splide('#gallery_thumb', {
        perPage: 5,
        gap: 10,
        speed: 100,
        rewind: false,
        pagination: false,
        cover: true,
        isNavigation: true,
        focus: 'center',
        breakpoints: {
          1000: {
            perPage: 4
          },
          500: {
            perPage: 2
          }
        }
      });
      gallery_main.sync(gallery_thumb);
      gallery_main.on('mounted resized', set_arrow_offset);
      gallery_thumb.on('mounted resized', set_arrow_offset);
      // count
      gallery_main.on('mounted move', function () {
        var current = gallery_main.index + 1;
        var all = gallery_main.length;
        var output = current + ' / ' + all;
        $('#gallery_count').text(output);
      });
      // slide height
      gallery_main.on('mounted resized', function () {
        var max_h = 0;
        var init_h = is_sp() ? 330 : 400;
        $('#gallery_main .splide__list .image').outerHeight(init_h);
        $('#gallery_main .splide__list .image img').each(function (i, el) {
          var h = $(el).outerHeight();
          if (h > max_h) {
            max_h = h;
          }
        });
        $('#gallery_main .splide__list .image').outerHeight(max_h);
      });gallery_main.mount();
      gallery_thumb.mount();
    }

    /*
     * メインビジュアル リサイズ
     */
    if ($('body').hasClass('page-company') || $('body').hasClass('page-franchise') || $('body').hasClass('page-profile')) {
      if (is_sp()) {
        var resize_h = $(window).innerHeight() - 125;
        $('.mainvisual, .mainvisual ul, .mainvisual li, .bx-wrapper').outerHeight(resize_h);
      }
    }

    /*
     * メインビジュアル リサイズ
     */
    if ($('body').hasClass('page-contact_hotel')) {
      $('select[name="hotels"] option').each(function () {
        var suffix = $(this).val().slice(-1);
        if ($.inArray(suffix, ['都', '道', '府', '県']) !== -1 || $(this).text() == 'ホテル名を選択してください') {
          $(this).prop('disabled', 'disabled');
        }
      });
    }
  });
})(jQuery);